/**
 * Estados de Disponibilidad
 * Vista de estados y disponibilidad de líneas de producción
 * Reutiliza la lógica de ProductionLineas para mostrar el estado operativo
 */
import ProductionLineas from '../production-lines/ProductionLineas'

function EstadosDisponibilidad() {
  return <ProductionLineas />
}

export default EstadosDisponibilidad
